module.exports = __webpack_public_path__ + "img/ic_list_profile.f12bf17b.png";